import EstimateCar from './EstimateCar';
import ResultEstimateCar from './components/Result.EstimateCar';

export { ResultEstimateCar };
export default EstimateCar;
